import { useTranslation } from '@pancakeswap/localization'
import { Text } from '@pancakeswap/uikit'
import { formatNumber } from '@pancakeswap/utils/formatBalance'
import Container from 'components/Layout/Container'
import { useRouter } from 'next/router'
import { Collection } from 'state/nftMarket/types'
import { useAccount } from 'wagmi'
import BannerHeader from '../components/BannerHeader'
import AvatarImage from '../components/BannerHeader/AvatarImage'
import BaseSubMenu from '../components/BaseSubMenu'
import MarketPageHeader from '../components/MarketPageHeader'
import MarketPageTitle from '../components/MarketPageTitle'
import StatBox, { StatBoxItem } from '../components/StatBox'
import { nftsBaseUrl } from '../constants'
import LowestPriceStatBoxItem from './LowestPriceStatBoxItem'
import TopBar from './TopBar'

interface HeaderProps {
  collection: Collection
}

const Header: React.FC<React.PropsWithChildren<HeaderProps>> = ({ collection }) => {
  const router = useRouter()
  const collectionAddress = router.query.collectionAddress as string
  const { totalSupply, numberTokensListed, totalVolumePLS, banner, avatar } = collection
  const { t } = useTranslation()
  const { address: account } = useAccount()
  const bannerPath = '/images/teams/home-banner.png'
  const volume = totalVolumePLS
    ? parseFloat(totalVolumePLS).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    : '0'

  const itemsConfig = [
    {
      label: t('Collection'),
      href: `${nftsBaseUrl}/collections/${collectionAddress}`,
    },
    {
      label: t('Traits'),
      href: `${nftsBaseUrl}/collections/${collectionAddress}#traits`,
    },
    {
      label: t('Activity'),
      href: `${nftsBaseUrl}/collections/${collectionAddress}#activity`,
    },
    {
      label: t('Profile'),
      href: `/profile/${account}`, // Modified to ensure it's an absolute path
    },
  ]

  return (
    <>
      <MarketPageHeader>
        <TopBar />
        <BannerHeader bannerImage={bannerPath} avatar={<AvatarImage src={avatar} />} />
        <MarketPageTitle
          address={collection.address}
          title={collection.name}
          description={collection.description ? <Text color="textSubtle">{t(collection.description)}</Text> : null}
        >
          <StatBox>
            {/*
              <StatBoxItem title={t('Items')} stat={formatNumber(Number(totalSupply), 0, 0)} />
           */}
            <StatBoxItem title={t('Items')} stat={formatNumber(Number('10000'), 0, 0)} />
            <StatBoxItem
              title={t('Items listed')}
              stat={numberTokensListed ? formatNumber(Number(numberTokensListed), 0, 0) : '0'}
            />
            <LowestPriceStatBoxItem collectionAddress={collection.address} />
            <StatBoxItem title={t('Vol. (%symbol%)', { symbol: 'PLS' })} stat={volume} />
          </StatBox>
        </MarketPageTitle>
      </MarketPageHeader>
      <Container>
        <BaseSubMenu
          items={account ? itemsConfig : itemsConfig.slice(0, 3)}
          activeItem={router.asPath}
          mt="24px"
          mb="8px"
        />
      </Container>
    </>
  )
}

export default Header
